// extracted by mini-css-extract-plugin
export default {"Layout":"Layout_Layout__Hsb9i","row":"Layout_row__AG0wm","col":"Layout_col__gvnYY"};